module.exports = __webpack_public_path__ + "img/traffic-right-icon.5205c54f.svg";